import { createSlice } from "@reduxjs/toolkit";
import { loginUserSelectInstitution, logoutUser } from "../actions/account";

const initialState = {
  tableFilters: {},
  columnFilters: {},
  selectedAllGoals: false,
  selectedGoalsIds: [],
  unselectedGoalsIds: [],
  tabValue: {},
  rowsPerPage: 20,
  selectedColumns: [],
  filterSideBar: false,
  sideBarTabValue: "Filters",
  logsTabCounts: {}
};

const goalsUISlice = createSlice({
  name: "goalsUI",
  initialState,
  reducers: {
    "account/logoutUser": (state) => initialState,
    storeGoalFilters(state, action) {
      state.tableFilters = action.payload;
    },
    clearGoalFilters(state, action) {
      state.tableFilters = {};
    },
    storeGoalColumnFilters(state, action) {
      state.columnFilters = action.payload;
    },
    setSelectedAllGoals(state, action) {
      state.selectedAllGoals = action.payload;
    },
    setSelectedGoalsIds(state, action) {
      state.selectedGoalsIds = action.payload;
    },
    setUnselectedGoalsIds(state, action) {
      state.unselectedGoalsIds = action.payload;
    },
    setTabValue(state, action) {
      const { id, value } = action.payload;
      state.tabValue = {
        ...state.tabValue,
        [id]: value,
      };
    },
    setSideBarTabValue(state, action) {
      state.sideBarTabValue = action.payload;
    },
    setRowsPerPage(state, action) {
      const { id, value } = action.payload;
      state.rowsPerPage = {
        ...state.rowsPerPage,
        [id]: value
      }
    },
    setSelectedColumns(state, action) {
      state.selectedColumns = action.payload;
    },
    setFilterSideBar(state, action) {
      state.filterSideBar = action.payload;
    },
    setLogsTabCount(state, action) {
      const { logId, tabIndex, count } = action.payload || {};
      if (!logId && logId !== 0) return;
      if (typeof tabIndex !== "number") return;
      state.logsTabCounts = {
        ...state.logsTabCounts,
        [logId]: {
          ...(state.logsTabCounts?.[logId] || {}),
          [tabIndex]: count,
        },
      };
    },

  },
  extraReducers: {
    [logoutUser.fulfilled]: (state) => {
      return initialState;
    },
    [logoutUser.rejected]: (state) => {
      return initialState;
    },
    [loginUserSelectInstitution.fulfilled]: (state) => {
      return initialState;
    },
    [loginUserSelectInstitution.rejected]: (state) => {
      return initialState;
    },
  },
});

export const getTableFilters = (state) => state.goalsUI.tableFilters;
export const getColumnFilters = (state) => state.goalsUI.columnFilters;
export const getSelectedAllGoals = (state) => state.goalsUI.selectedAllGoals;
export const getSelectedGoalsIds = (state) => state.goalsUI.selectedGoalsIds;
export const getUnselectedGoalsIds = (state) => state.goalsUI.unselectedGoalsIds;
export const getTabValue = (state) => state.goalsUI.tabValue;
export const getRowsPerPage = (state) => state.goalsUI.rowsPerPage;
export const getSelectedColumns = (state) => {
  return state.goalsUI.selectedColumns;
}
export const getFilterSideBar = (state) => state.goalsUI.filterSideBar;
export const getSideBarTabValue = (state) => state.goalsUI.sideBarTabValue;
export const getLogsTabCounts = (state) => state.goalsUI.logsTabCounts;

export const {
  storeGoalFilters,
  clearGoalFilters,
  storeGoalColumnFilters,
  setSelectedAllGoals,
  setSelectedGoalsIds,
  setUnselectedGoalsIds,
  setTabValue,
  setRowsPerPage,
  setSelectedColumns,
  setFilterSideBar,
  setSideBarTabValue,
  setLogsTabCount
} = goalsUISlice.actions;

export default goalsUISlice;
